import api from './api'

export const healthService = {
  // Get all health records
  async getHealthRecords(page = 1, limit = 20) {
    const response = await api.get(`/health/records?page=${page}&limit=${limit}`)
    return response.data
  },

  // Get health summary
  async getHealthSummary() {
    const response = await api.get('/health/summary')
    return response.data
  },

  // Upload health photo
  async uploadHealthPhoto(photoFile, title, description, userPrompt = '') {
    const formData = new FormData()
    formData.append('photo', photoFile)
    formData.append('title', title)
    formData.append('description', description)
    if (userPrompt) {
      formData.append('userPrompt', userPrompt)
    }

    const response = await api.post('/health/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Get specific health record
  async getHealthRecord(recordId) {
    const response = await api.get(`/health/${recordId}`)
    return response.data
  },

  // Get analysis status
  async getAnalysisStatus(recordId) {
    const response = await api.get(`/health/${recordId}/status`)
    return response.data
  },

  // Delete health record
  async deleteHealthRecord(recordId) {
    const response = await api.delete(`/health/${recordId}`)
    return response.data
  },

  // Ask health question based on history
  async askHealthQuestion(question, context = '') {
    const response = await api.post('/health/chat', {
      question,
      context
    })
    return response
  }
}
